import { useEffect } from "react";
import { useStytchMember } from "@stytch/react/b2b";
import { PrimeDebugLog } from "./debugLog";

import * as amplitude from "@amplitude/analytics-browser";
import { sessionReplayPlugin } from "@amplitude/plugin-session-replay-browser";

const AMPLITUDE_DEV_KEY = "36f151576fa0e8cdba5b230d789ddac8";
const AMPLITUDE_PROD_KEY = "c6cd519bf8c4dd4eb227e59e3943585c";

export function useSetupAnalytics() {
    const { member } = useStytchMember();

    useEffect(() => {
        const sessionReplayTracking = sessionReplayPlugin({
            forceSessionTracking: true,
            sampleRate: 1,
        });
        amplitude.add(sessionReplayTracking);

        const amplitudeKey = window.location.hostname.endsWith("primepoint.ai")
            ? AMPLITUDE_PROD_KEY
            : AMPLITUDE_DEV_KEY;
        amplitude.init(amplitudeKey, member?.email_address, {
            autocapture: true,
        });
    }, [member?.email_address]);
}

export function analyticsEvent(eventName: string, params?: any) {
    PrimeDebugLog("Analytics", `Event: ${eventName}`, params);
    amplitude.track(eventName, params);
}

export const AnalyticsEvents = {
    // Downloaded a table in a regular Marvin response
    DOWNLOAD_TABLE: "download_table",

    // Copied a table in a regular Marvin response
    COPY_TABLE: "copy_table",

    // User sent a request to generate a spreadsheet
    REQUEST_GENERATE_SPREADSHEET: "request_generate_spreadsheet",

    // Downloaded a spreadsheet from spreadsheet workflow
    DOWNLOAD_SPREADSHEET: "download_spreadsheet",

    // Copied a spreadsheet from spreadsheet workflow
    COPY_SPREADSHEET: "copy_spreadsheet",

    // Sent any message to Marvin
    SEND_MESSAGE: "send_message",

    // Sent any message to Marvin
    CREATE_CONVERSATION: "create_conversation",

    // Viewed a reference in a conversation
    CONVERSATION_VIEW_REFERENCE: "view_reference",

    // User opened a node in the file viewer
    VIEW_NODE: "view_node",

    // User hovered over a connection
    CONNECTION_HOVER: "connection_hover",

    // User clicked on a connection
    CONNECTION_CLICK: "connection_click",
};
